import { AppConfigContext } from '@App/AppConfigContext';
import { Experiments } from '@Config/Experiments';
import { activateExperimentViaFock } from '@Framework/tracking';
import React, { useContext, useState } from 'react';
import { Route, Routes as Switch } from 'react-router';

import { ProvidersPage } from './providers/providersPage';
import { SelectionPage } from './selection/selectionPage';

const TreatmentNow = (props): React.ReactElement => {
  return (
    <>
      <Switch>
        <Route path={'/'} element={<SelectionPage />} />
        <Route path={'/:insurance'} element={<ProvidersPage />} />
      </Switch>
    </>
  );
};

export { TreatmentNow };
